var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMarkerYajaOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 56,
  viewBox: "0 0 34 56"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "outline",
  fillRule: "nonzero",
  stroke: "#F8E71C",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M22.73 31.943 17.055 46.6 11.4 31.993A16.01 16.01 0 0 1 1 17C1 8.163 8.163 1 17 1s16 7.163 16 16c0 6.66-4.12 12.588-10.27 14.943z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DF3D61",
  stroke: "#B23254",
  d: "M12.55 30.804A14.51 14.51 0 0 1 2.5 17C2.5 8.992 8.992 2.5 17 2.5S31.5 8.992 31.5 17a14.51 14.51 0 0 1-9.922 13.762l-4.522 11.682-4.507-11.64z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BBBDC0",
  d: "M11.517 14.932c-.954 0-1.732.818-1.732 1.824 0 1.005.778 1.822 1.732 1.822.955 0 1.732-.817 1.732-1.822s-.777-1.824-1.732-1.824m0 4.34c-1.319 0-2.39-1.129-2.39-2.516s1.071-2.516 2.39-2.516c1.318 0 2.39 1.128 2.39 2.516 0 1.387-1.072 2.515-2.39 2.515m13.343 1.086h-3.19l1.595-2.908 1.595 2.907zm-5.092-2.908 1.596 2.907h-3.19zm-1.594-4.294h3.19l-1.596 2.907zm4.711 3.6-1.369 2.495-1.368-2.494 1.368-2.495 1.37 2.495zm.38-.692-1.593-2.908h3.188zm2.735-3.6h-8.967l2.355 4.293-2.355 4.294H26l-2.354-4.294z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.517 12.694c-2.128 0-3.86 1.822-3.86 4.062s1.732 4.063 3.86 4.063 3.859-1.823 3.859-4.063-1.73-4.062-3.859-4.062m0 8.818C9.027 21.512 7 19.378 7 16.756S9.027 12 11.517 12s4.518 2.134 4.518 4.756-2.027 4.756-4.518 4.756m14.103-8.357.38-.693h-8.967l.381.693h3.95l-4.33 7.894h.777l3.705-6.787 3.725 6.787H26l-4.328-7.894z"
}))));
export default SvgMarkerYajaOn;